<template>
  <div class="text-left">
    <!-- <div class="card-title border-bottom p-3 mb-0 header-title">{{$t('common.upload_resume.steps.step2.title')}}</div> -->
    <div class="">
      <!-- <div class="alert alert-danger" v-if="errorMessage">
        {{errorMessage}}
      </div> -->
      <b-form-group id="fileInput" ref="uploadFile" class="dragdrop" v-if="!model.success">
        <b-form-file
          multiple
          accept=".docx, .pdf, .doc, .xlsx"
          v-model="files" 
          :placeholder="'Upload Resume*'" 
          @input="onInputResume()"
          :style="`${files.length ? 'display: none;' : ''}`"
        />

      </b-form-group>
      <b-form-group id="fileinputedlist" class="dragdrop">
        <b-col class="custom-file-layout" sm="12" xl="12" v-if="files.length" v-cloak>
  
          <b-list-group>
            <b-list-group-item 
              class="d-flex justify-content-between p-1 mb-2"
              style="border-width: 1;"
              v-for="(file, idx) in files" 
              :key="idx"
            >
              <span class="d-inline-flex align-items-center text-muted ml-1 mr-3">
                <i class="uil-file-upload mr-2" style="font-size: 17px;"/>
                <a class="h6" href="javascript:void(0)"
                  @click="viewThisFile(idx, !!file.isUploaded)"
                >
                  {{ formattedFileName(file.name) }}
                </a>
              </span>
  
              <b-button variant="outline-danger" size="sm" @click="remove(idx, file)">
                <b-icon-trash></b-icon-trash>
              </b-button>
  
            </b-list-group-item>
        
            <span class="d-inline-flex align-items-center text-muted ml-1 mr-3">
              <div class="inputWrapper" style="height: 24px;">
                + Add file
                <b-form-file class="add-new-file hidden"
                  multiple
                  accept=".docx, .pdf, .doc, .xlsx"
                  v-model="additional_files" 
                  @input="onAddFile()"
                />
              </div>
            </span>
          </b-list-group>
  
        </b-col>

      </b-form-group>

      <div class="alert alert-success text-center" v-if="model.success">
        Successfully Uploaded!
      </div>

      <div class="row mt-5">
        <TextField 
          :placeholder="$t('common.upload_resume.steps.step2.email.placeholder')"
          :label="$t('common.upload_resume.steps.step2.email.label') + '(leave empty if not applicable).'"
          v-model="model.email"
          type="text" 
          class="col-md-12"
          customizedMessage="New"
          :errorMessage="(!emailValid.test(model.email) || errorEmailMessage == 'Email address already exists') && errorEmailMessage"
          :error="(!emailValid.test(model.email) || errorEmailMessage == 'Email address already exists') && errorEmailMessage"
        />
        <TextField 
          :placeholder="$t('common.upload_resume.steps.step2.first_name.placeholder')"
          :label="$t('common.upload_resume.steps.step2.first_name.label') + '*'"
          v-model="model.first_name"
          type="text"
          class="col-md-6"
          :errorMessage="model.first_name == '' && errorMessage"
          :error="model.first_name == '' && errorMessage"
        />

        <TextField 
          :placeholder="$t('common.upload_resume.steps.step2.last_name.placeholder')"
          :label="$t('common.upload_resume.steps.step2.last_name.label') + '*'"
          v-model="model.last_name"
          type="text"
          class="col-md-6"
          :errorMessage="model.last_name == '' && errorMessage"
          :error="model.last_name == '' && errorMessage"
        />
      </div>
      <div class="row">
        <TextField 
          :placeholder="$t('common.upload_resume.steps.step2.jp_first_name.placeholder')"
          :label="$t('common.upload_resume.steps.step2.jp_first_name.label')"
          v-model="model.jp_first_name"
          type="text"
          class="col-md-6"
        />

        <TextField 
          :placeholder="$t('common.upload_resume.steps.step2.jp_last_name.placeholder')"
          :label="$t('common.upload_resume.steps.step2.jp_last_name.label')"
          v-model="model.jp_last_name"
          type="text"
          class="col-md-6"
        />
      </div>
      <div class="row">
        <!-- <CustomSelect
          autoload
          :customData="gender_options"
          moduleName="cityList"
          valueField="value"
          textField="text"
          class="col-md-6"
          placeholder="Select Gender"
          :label="$t('common.upload_resume.steps.step2.gender.label')"
          v-model="model.gender"
        /> -->
        <Select
          autoload
          moduleName="genderType"
          valueField=""
          textField=""
          class="col-md-6"
          placeholder="Select Gender"
          :label="$t('common.upload_resume.steps.step2.gender.label')"
          v-model="model.gender"
        />

        <DateTime
          class="form-group textOnInput col-md-6"
          v-model="model.date_of_birth"
          :placeholder="$t('common.upload_resume.steps.step2.date_of_birth.placeholder')"
          :label="$t('common.upload_resume.steps.step2.date_of_birth.label')"
          @input="onChangeDate"
        />
        
        <div class="col-md-12">
          <div class="row">
            <TextField 
              :placeholder="$t('common.upload_resume.steps.step2.country.placeholder')"
              :label="$t('common.upload_resume.steps.step2.country.label')"
              v-model="model.country"
              type="text"
              class="col-md-6"
            />

            <!-- <CustomSelect
              autoload
              :customData="city_option"
              moduleName="cityList"
              valueField="value"
              textField="text"
              class="col-md-6"
              :placeholder="$t('job.form.city.placeholder')"
              :label="$t('common.upload_resume.steps.step2.city.label')"
              v-model="model.city"
            /> -->
            <Select
              autoload
              moduleName="cityList"
              valueField=""
              textField=""
              class="col-md-6"
              :placeholder="$t('job.form.city.placeholder')"
              :label="$t('common.upload_resume.steps.step2.city.label')"
              v-model="model.city"
            />

            <TextField 
              :placeholder="$t('common.upload_resume.steps.step2.contact_no.placeholder')"
              :label="$t('common.upload_resume.steps.step2.contact_no.label')"
              v-model="model.contact_no"
              type="text"
              class="col-md-6"
            />

            <CustomSelect
              autoload
              :customData="contact_types_option"
              moduleName="cityList"
              valueField="value"
              textField="text"
              class="col-md-6"
              label="Type"
              v-model="model.contact_type"
            />

            <TextField 
              placeholder="Enter Current Company"
              label="Current Company"
              v-model="model.current_company"
              type="text"
              class="col-md-6"
            />

            <TextField 
              placeholder="Enter Current Role"
              label="Current Role"
              v-model="model.current_role"
              type="text"
              class="col-md-6"
            />

            <TextField 
              placeholder="Enter Current Salary"
              label="Current Salary"
              v-model="model.current_salary"
              type="number"
              class="col-md-6"
            />

            <TextField 
              placeholder="Enter Expected Salary"
              label="Expected Salary"
              v-model="model.expected_salary"
              type="number"
              class="col-md-6"
            />

            <Select
              autoload
              moduleName="languageLevels"
              valueField=""
              textField=""
              class="col-md-6"
              :placeholder="$t('common.upload_resume.steps.step2.japanese_level.placeholder')"
              :label="$t('common.upload_resume.steps.step2.japanese_level.label')"
              v-model="model.japanese_level"
            />

            <Select
              autoload
              moduleName="languageLevels"
              valueField=""
              textField=""
              class="col-md-6"
              :placeholder="$t('common.upload_resume.steps.step2.english_level.placeholder')"
              :label="$t('common.upload_resume.steps.step2.english_level.label')"
              v-model="model.english_level"
            />

            <Multiselect
              autoload
              moduleName="tag"
              endpoint="all"
              v-model="model.tag"
              :searchable="true"
              :multiple="true"
              :placeholder="$t('tag.form.select.placeholder')"
              :clear-on-select="false"
              :close-on-select="false"
              :show-labels="false"
              track-by="_id"
              label="name"
              :textLabel="$t('tag.form.select.label')"
              class="col-md-6"
            />

            <Select
              autoload
              moduleName="candidate_source"
              endpoint="all"
              valueField=""
              class="col-md-6"
              :placeholder="$t('candidate_source.form.select.placeholder')"
              :label="$t('candidate_source.form.select.label')"
              v-model="model.candidate_source"
              textField="name"
              trackBy="_id"
            />

            <TextField 
              placeholder="Enter Link"
              label="Link"
              v-model="model.source_url"
              type="text"
              class="col-md-6"
            />

            <Multiselect
              autoload
              moduleName="category"
              endpoint="all"
              v-model="model.category"
              :searchable="true"
              :multiple="true"
              :placeholder="$t('work_experience.form.select.placeholder')"
              :clear-on-select="false"
              :close-on-select="false"
              :show-labels="false"
              track-by="_id"
              label="name"
              :textLabel="$t('work_experience.form.select.label')"
              class="col-md-6"
            />

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group textOnInput">
            <label for="">{{$t('common.upload_resume.steps.step2.summary.label')}}</label>
            <textarea 
              class="form-control"
              :placeholder="$t('common.upload_resume.steps.step2.summary.placeholder')"
              v-model="model.summary"
              rows="10"
            >
            </textarea>
          </div>
        </div>
      </div>
    </div>

    <Loading :loading="loading"/>

    <OffCanvas
      customizedClass="custom-overlay-none"
      width="1298"
      position="start"
      autoload
      title="Document"
      ref="viewCandidateResume"
      :parameters="{source_path}"
      :component="viewCandidateResumeComponent"
      @onClose="isPreview = false"
    />
  </div>
</template>


<script>
import { mapActions } from 'vuex'
// import DropDown from '@components/form/dropdown.vue'
import Select from '@components/form2/select'
import TextField from '@components/form2/textfield.vue'
import DateTime from '@components/form2/dateTime.vue'
import CustomSelect from '@components/form2/select/customSelect.vue'
import Dropdown from '@src/static/dropdown'
import NProgress from 'nprogress/nprogress'
import OffCanvas from '@components/offcanvas'
import Loading from '@components/LoadingSpinner'
import Multiselect from '@components/form2/select/multiselect'
import error from '@utils/error'

export default {
  data(){
    return {
      Dropdown,
      model:{
        email:'',
        first_name:'',
        last_name:'',
        contact_no:'',
        contact_type:'home',
        date_of_birth:'',
        gender:'',
        country:'',
        city:'',
        summary:'',
        current_company:'',
        current_role:'',
        current_salary:'',
        expected_salary:'',
        japanese_level:'',
        english_level:'',
      },
      files:[],
      additional_files:[],
      contact_types_option:[
        { value: 'home', text: 'Home' },
        { value: 'work', text: 'Work' },
        { value: 'mobile', text: 'Mobile' }
      ],
      gender_options:[
        { value: '', text: 'Select a Gender' },
        { value: 'male', text: 'Male' },
        { value: 'female', text: 'Female' }
      ],
      city_option: [
        { value: '', text: 'Select a City' },
      ],
      errorMessage:'',
      errorEmailMessage:'',
      is_exist: true,
      source_path: '',
      file_count: 0,
      loading: false,
      isPreview: false,
      original_email: '',
      isEdit: false,
      removed: [],
      //eslint-disable-next-line
      emailValid: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
  },
  props:['data', 'job_id', 'candidateID'],
  components:{ 
    Select, 
    TextField, 
    CustomSelect, 
    DateTime, 
    OffCanvas, 
    Loading, 
    Multiselect 
  },
  computed: {
    viewCandidateResumeComponent() {
      return () => import('../dialogs/viewCandidateResume.vue')
    }
  },
  methods:{
    ...mapActions('user', ['prospectStep_1', 'prospectUploadCVs']),
    ...mapActions('candidate', ['create', 'update', 'uploadTemporaryFiles', 'findByEmail']),
    async validate() {
      this.errorEmailMessage = ''
      this.errorMessage = ''

      if(this.emailValid.test(this.model.email) && (this.original_email != this.model.email) && this.model.email != "") {
        await this.findByEmail(this.model)
        .then( res => {
          let { data } = res
          if(data.length) {
            this.errorEmailMessage = 'Email address already exists'
            this.is_exist = true
          }else {
            this.errorEmailMessage = ''
            this.is_exist = false
          }
        })
      }else {
        this.is_exist = false
      }

      if (!this.emailValid.test(this.model.email) && this.model.email != "") {
        this.errorEmailMessage = 'Please provide a valid email address.'
        return false
      }
      else if (this.is_exist){
        this.errorEmailMessage = 'Email address already exists'
        this.is_exist = false
        return false
      }
      else if (this.model.first_name == '' || this.model.last_name == '') {
        this.errorMessage = 'Please fill the required fields.'
        return false
      }else{
        var isValid = false
        let isError = false

        var formData = new FormData();
        if(this.files){
          this.files.forEach((file) => {
            formData.append("files", file);
          });
        }

        if(this.removed) {
          this.removed.forEach((id) => {
            formData.append("removed_ids", id);
          });
        }
        
        formData.append("id", this.model._id);
        formData.append("last_name", this.model.last_name);
        formData.append("first_name", this.model.first_name);
        formData.append("jp_first_name", this.model.jp_first_name);
        formData.append("jp_last_name", this.model.jp_last_name);
        formData.append("summary", this.model.summary);
        formData.append("industry", this.model.industry);
        formData.append("country", this.model.country);
        formData.append("city", this.model.city);
        formData.append("contact_no", this.model.contact_no);
        formData.append("contact_type", this.model.contact_type);
        formData.append("date_of_birth", this.model.date_of_birth ? this.model.date_of_birth : undefined);
        formData.append("gender", this.model.gender);
        formData.append("email", this.model.email);
        formData.append("current_company", this.model.current_company._id);
        formData.append("current_role", this.model.current_role);
        formData.append("current_salary", this.model.current_salary);
        formData.append("expected_salary", this.model.expected_salary);
        formData.append("english_level", this.model.english_level);
        formData.append("japanese_level", this.model.japanese_level);
        formData.append("job_id", this.job_id);
        formData.append("candidate_source", this.model.candidate_source ? this.model.candidate_source._id : undefined);
        formData.append("source_url", this.model.source_url);
        if(this.model.tag){
          for (const tag of this.model.tag) {
            formData.append('tag[]', tag._id);
          }
        }
        if(this.model.category){
          for (const category of this.model.category) {
            formData.append('category[]', category._id);
          }
        }

        NProgress.start()
        this.loading = true
        this.$refs.viewCandidateResume.hide()
        if(!this.job_id){
          if(!this.isEdit) {
            await this.create(formData).then(res => {
              if(res.data){
                this.$emit('onCLose', {candidate_id: res.data._id})
                NProgress.done()
                this.loading = false
              }
            }).catch(err => {
              let message = err.response ? err.response.data ? err.response.data.errorMessage : "Internal Error" : "Internal Error"
              NProgress.done()
              this.loading = false
              return error.errorHandler({ message }, this.$bvToast)
            })
          }else {
            await this.update(formData)
            .then(res => {
              if (res && res.data) {
                this.$emit('onCLose', {candidate_id: res.data._id})
                NProgress.done()
                this.loading = false
              }
            }).catch(err => {
              let message = err.response ? err.response.data ? err.response.data.errorMessage : "Internal Error" : "Internal Error"
              NProgress.done()
              this.loading = false
              return error.errorHandler({ message }, this.$bvToast)
            })
          }
        }else {
          if(this.files.length > 0){
            await this.prospectUploadCVs(formData).then(res => {
              if(res.data.success){
                this.model = res.data.user
                isValid = true
              }else{
                this.errorMessage = res.data.errorMessage
                if(res.data.vincereError){
                  isError = true
                }
              }
              NProgress.done()
              this.loading = false
            }).catch(err => {
              this.errorMessage = err.errorMessage
              NProgress.done()
            })
            this.$emit('on-validate', {user:this.model}, isValid, isError)
            return isValid
          }else{
            this.model.job_id = this.job_id
            await this.prospectStep_1(this.model)
            .then(res => {
              if(res.data.success){
                this.model = res.data.user
                isValid = true
              }else{
                this.errorMessage = res.data.errorMessage
                if(res.data.vincereError){
                  isError = true
                }
              }
              NProgress.done()
              this.loading = false
            })
            
            this.$emit('on-validate', {user:this.model}, isValid, isError)
            return isValid
          }
        }
        
      }
    },
    reset(){
      this.model = {
        email:'',
        first_name:'',
        last_name:'',
        contact_no:'',
        contact_type:'home',
        date_of_birth:'',
        gender:null,
        country:'',
        city:'',
        summary:'',
        current_company:'',
        current_role:'',
        current_salary:'',
        expected_salary:'',
        japanese_level:'',
        english_level:'',
        job_id: ''
      }
      this.errorMessage = '',
      this.files = []
    },
    getCityList(){
      let cityList = this.Dropdown.cityList
      for(let key in cityList){
        let city = {}
        city.value = cityList[key]
        city.text = cityList[key]
        this.city_option.push(city)
      }
    },
    async onInputResume(idx = 0, isUploaded = false) {
      let files = this.files
      if(files && files.length){
        NProgress.start()
        this.loading = true
        if(!isUploaded) {
          var formData = new FormData();
  
          formData.append("files", files[idx]);
          this.file_count = idx
  
          await this.uploadTemporaryFiles(formData)
          .then(res => {
            let { file, data } = res.data
            let { profile, parsing, sovren } = data
            if (profile && parsing) {
              let modelData = {
                email: this.model.email != '' ? this.model.email : profile.info.email,
                first_name: this.model.first_name != '' ? this.model.first_name : profile.info.first_name,
                last_name: this.model.last_name != '' ? this.model.last_name : profile.info.last_name,
                jp_first_name: this.model.jp_first_name != '' ? this.model.jp_first_name : '',
                jp_last_name: this.model.jp_last_name != '' ? this.model.jp_last_name : '',
                contact_no: this.model.contact_no != '' ? this.model.contact_no : profile.info.phone,
                contact_type: this.model.contact_type != '' ? this.model.contact_type : 'home',
                date_of_birth: this.model.date_of_birth != '' ? this.model.date_of_birth : profile.info.date_birth,
                gender: (this.model.gender != '' && this.model.gender != null) ? this.model.gender : profile.info.gender,
                country: this.model.country != '' ? this.model.country : parsing.location ? parsing.location.geojson ? parsing.location.geojson.country : '' : '',
                city: this.model.city != '' ? this.model.city : parsing.location ? parsing.location.geojson ? parsing.location.geojson.state_district : '' : '',
                summary: this.model.summary != '' ? this.model.summary : profile.info.summary,
                current_company: this.model.current_company != '' ? this.model.current_company : parsing.experiences.length > 0 ? parsing.experiences[0].company : '',
                current_role: this.model.current_role != '' ? this.model.current_role : parsing.experiences.length > 0 ? parsing.experiences[0].title : '',
                current_salary: this.model.current_salary != '' ? this.model.current_salary : '',
                expected_salary: this.model.expected_salary != '' ? this.model.expected_salary : '',
                japanese_level: this.model.japanese_level != '' ? this.model.japanese_level : '',
                english_level: this.model.english_level != '' ? this.model.english_level : '',
                profile,
                parsing
              }
              this.model = modelData
              if(this.isEdit){
                this.model._id = this.candidateID
              }
            } else if (sovren) {
              let modelData = {
                email: sovren.email,
                first_name: sovren.first_name,
                last_name: sovren.last_name,
                contact_no: sovren.phone,
                contact_type:'home',
                date_of_birth: sovren.date_birth,
                gender:sovren.gender,
                country: '',
                city: '',
                summary: sovren.summary,
                current_company: sovren.work.length > 0 ? sovren.work[0].EmployerOrgName : '',
                current_role: sovren.work.length > 0 ? sovren.work[0].Title : '',
                current_salary:'',
                expected_salary:'',
                japanese_level:'',
                english_level:'',
                sovren
              }
              this.model = modelData
              if(this.isEdit){
                this.model._id = this.candidateID
              }
            }

            this.onShowFile(file[0].path)
          }).catch(err => {
            this.files = []
            let message = err.response ? err.response.data ? err.response.data.errorMessage : "Internal Error" : "Internal Error"
            NProgress.done()
            this.loading = false
            return error.errorHandler({ message }, this.$bvToast)
          })
        }else {
          this.onShowFile(files[idx].path)
        }
      }
    },
    formattedFileName(name) {
      return name.replace(/.docx|.pdf|.doc|.xlsx/gi, ".pdf");
    },
    onShowFile(path) {
      this.source_path = path
      this.$refs.viewCandidateResume.show()
      this.isPreview = true
      NProgress.done()
      this.loading = false
    },
    onAddFile() {
      let files = this.additional_files
      files.forEach((file) => {
        const isLt5M = file.size > 5 * 1024 * 1024;
        if(isLt5M){
          let message = 'File size exceeds 5mb.'
          return error.errorHandler({ message }, this.$bvToast)
        }else{
          this.files.push(file)
        }
      });
      this.additional_files = []
    },
    viewThisFile(idx, isUploaded) {
      if(idx != this.file_count) {
        this.$refs.viewCandidateResume.hide()
        this.onInputResume(idx, isUploaded)
      } else {
        if(!this.isPreview)
          this.onInputResume(idx, isUploaded)
      }
    },
    remove(idx, file) {
      this.files.splice(idx, 1)
      if(idx == this.file_count) {
        this.$refs.viewCandidateResume.hide()
        this.onInputResume(0, file.isUploaded)
      }

      if(this.isEdit && file._id) {
        this.removed.push(file._id)
      }

    },
    fetchData() {
      let param = {}
      param.id = this.candidateID

      return this.$store.dispatch('candidate/findCandidate', param)
      .then(res => {
        if (res && res.data) {
          this.model = {...res.data}
          this.original_email = res.data.email
          this.files = []
          this.isEdit = true
          this.parseDocuments()
        }
      })
    },
    parseDocuments(){
      let attachmentData = this.model.attachments
      if(attachmentData.length > 0){
        for(let index = 0; index < attachmentData.length; index++) {
          const element = attachmentData[index];
          if(element.mimetype === 'application/pdf') {
            let result = {
              name: element.originalname,
              size: element.size,
              _id: element._id,
              path: element.path,
              isUploaded: true
            }
            this.files.push(result)
          }
        }
      }
    },
    onChangeDate(date) {
      this.model.date_of_birth = date
    }
  },
  mounted() {
    this.getCityList()
    /* console.log(this.$parent.$attr)
    console.log(this.$parents)
     */
    /* this.model = this.$props['data'] || {} */
    if(!this.role_modules.some(item => item.value == 'job.submit_candidate')) {
      let { first_name, last_name, email, contact_no } = this.user
      this.model.first_name = first_name
      this.model.last_name = last_name
      this.model.email = email
      this.model.contact_no = contact_no
    }

    if(this.candidateID) {
      this.fetchData()
    }
  },
  watch: { 
    data: function(newVal) { // watch it
     this.model = newVal
    }
  }
}
</script>

<style lang="scss">
.inputWrapper {
  overflow: hidden;
  position: relative;
  cursor: pointer;
  background-color: transparent;
  color: blue;
}

.add-new-file {
  cursor: pointer;
  height: 100%;
  position:absolute;
  top: 0;
  right: 0;
  font-size:50px;
}
.hidden {
  /*Opacity settings for all browsers*/
  opacity: 0;
  -moz-opacity: 0;
  filter:progid:DXImageTransform.Microsoft.Alpha(opacity=0)
}


/*Dynamic styles*/
.inputWrapper:hover {
  background-color: transparent;
}
.inputWrapper.clicked {
  background-color: transparent;
}

</style>